module.exports = __webpack_public_path__ + "img/公安警情大数据智能研判作战平台.287b1209.png";